/* eslint-disable spaced-comment */
export default {
  dbh_calendar_year: 'Year',
  dbh_calendar_month: 'Month',

  /**** 月份 ****/
  dbh_january: 'Jan',
  dbh_february: 'Feb',
  dbh_march: 'Mar',
  dbh_april: 'Apr',
  dbh_may: 'May',
  dbh_june: 'June',
  dbh_july: 'July',
  dbh_august: 'Aug',
  dbh_september: 'Sept',
  dbh_october: 'Oct',
  dbh_november: 'Nov',
  dbh_december: 'Dec',
  /**** 月份 ****/

  /**** 周 ****/
  dbh_monday: 'Mon',
  dbh_tuesday: 'Tues',
  dbh_wednesday: 'Wed',
  dbh_thursday: 'Thur',
  dbh_friday: 'Fri',
  dbh_saturday: 'Sat',
  dbh_sunday: 'Sun',
  /**** 周 ****/

  dbh_more: 'More',
  dbh_today: 'Today',
  dbh_week_monday: 'Mon',
  dbh_week_tuesday: 'Tues',
  dbh_week_wednesday: 'Wed',
  dbh_week_thursday: 'Thur',
  dbh_week_friday: 'Fri',
  dbh_week_saturday: 'Sat',
  dbh_week_sunday: 'Sun',


};
